import request from '@/utils/request';

export function getUserGroups(params?: Record<string, any>) {
  return request({
    url: '/user-group',
    method: 'get',
    params,
  });
}

export function getUserGroup(id: number) {
  return request({
    url: '/user-group',
    method: 'get',
    params: { id },
  });
}

export function getUsers(params?: Record<string, any>) {
  return request({
    url: '/user',
    method: 'get',
    params,
  });
}

export function reset2fa(data) {
  return request({
    url: `/user/${data.id}/reset-2fa`,
    method: 'patch',
  });
}

export function resetPassword(data) {
  return request({
    url: `/user/${data.id}/reset-password`,
    method: 'patch',
  });
}

export function getPasswordToken(id) {
  return request({
    url: `/user/${id}/password-token`,
    method: 'get',
  });
}

export function saveUser(data) {
  return request({
    url: '/user/save',
    method: 'post',
    data: data,
  });
}

export function saveUserGroup(data) {
  return request({
    url: '/user-group/save',
    method: 'post',
    data: data,
  });
}

export function deleteUserGroup(id) {
  return request({
    url: `/user-group/${id}`,
    method: 'delete',
  });
}

export function toggleStatus(id) {
  return request({
    url: `/user/${id}/toggle-status`,
    method: 'patch',
  });
}

export function toggleCensor(id) {
  return request({
    url: `/user/${id}/toggle-censor`,
    method: 'patch',
  });
}

export function toggleEnforce2fa(id) {
  return request({
    url: `/user/${id}/toggle-enforce-2fa`,
    method: 'patch',
  });
}
